export const transform = {
    // Transform from API representation.
    fromApi: data => ({
        id: data.id,
        name: data.name,
        value: data.value === null ? '' : data.value,
        required: data.required,
        editable: data.editable,
    }),

    // Transform from API representation.
    toApi: data => data,
};

export interface LineItemField {
    editable: boolean;
    id: string;
    name: string;
    required: boolean;
    value: string;
}